/* eslint-disable max-len */
document.addEventListener( 'DOMContentLoaded', function () {
  let windowWidth = window.innerWidth;

  function checkScroll() {
    if ( window.scrollY > 60 ) {
      document.body.classList.add( 'scrolled' );
    } else {
      document.body.classList.remove( 'scrolled' );
    }
  }

  function setMainMarginTop() {
    const header = document.querySelector( 'header' );
    const main = document.querySelector( '.transparent-header main, .transparent-header .entry-content, .error404 main' );
    if ( header && main && ( windowWidth > 1199 ) ) {
      const headerHeight = header.offsetHeight;
      main.style.marginTop = -headerHeight + 'px';
    } else if ( main ) {
      main.style.marginTop = '0';
    }
  }

  checkScroll();
  setMainMarginTop();

  window.onscroll = checkScroll;

  window.onresize = function() {
    if ( window.innerWidth != windowWidth ) {
      windowWidth = window.innerWidth;
      setMainMarginTop();
      checkScroll();
    }
  };
} );
